import {styled} from "@mui/material";

export const AdditionalServiceWarehouseCardContainer = styled("div")(() => ({
    backgroundColor: '#FFF',
    borderRadius: '0.5rem',
    height: '6.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '1rem'
}));